/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Frekvence opakování DHTMLX Scheduler události
 *
 * V dokumentaci je často označováno jako "type", ale stejně je pojmenován
 * i celý řetězec "rec_type", takže bylo zvoleno pojmenování "frequency",
 * aby se předešlo zmatku.
 * Podobné pojmenování pro tento číselník používá i iCalendar (FREQ).
 *
 * Zdroje:
 * - [type v DHTMLX Recurring Events](https://docs.dhtmlx.com/scheduler/recurring_events.html)
 * @enum {string}
 */
const DhtmlxRecFrequency = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year'
};

export default DhtmlxRecFrequency;
